/*** IMPORTS FROM imports-loader ***/
(function() {
var mp = window.mp;
var exports = undefined;
var define = undefined;
var module = undefined;

/* eslint camelcase: 0, no-var: 0 */
/* globals _, mp */

_.namespace(`mp.marketing.trends.reports`, function(ns) {
  'use strict';

  var old_models = [
    mp.marketing.trends.utils.IPHONE_X,
    mp.marketing.trends.utils.IPHONE_8,
    mp.marketing.trends.utils.IPHONE_8_PLUS,
    mp.marketing.trends.utils.OTHER_IPHONE,
  ];
  var release_models = [
    mp.marketing.trends.utils.IPHONE_XS,
    mp.marketing.trends.utils.IPHONE_XS_MAX,
    mp.marketing.trends.utils.IPHONE_XR,
  ];
  var IPhoneXS = mp.marketing.trends.widgets.PhoneAdoption.extend({
    get_display_models() {
      return release_models.concat(old_models);
    },
    get_release_models() {
      return release_models;
    },
    get_visible_models() {
      return release_models.concat(old_models.slice(0, 3));
    },
    get_query_name() {
      return mp.marketing.trends.utils.IPHONE_QUERY;
    },
    getDownloadName() {
      return ns.IPhoneXS.nice_name;
    },
  });

  Object.assign(IPhoneXS, {
    slug: `iphone_Xs`,
    nice_name: `iPhone XR, XS, and XS Max adoption`,
    description: `How quickly will people start using the new iPhone XR, iPhone XS, or iPhone XS Max?`,
  });
  ns.IPhoneXS = IPhoneXS;
});

}.call(window));